/*

{{ $t('邀约点数余量') }}

$t('邀约点数余量')

this.$t('邀约点数余量')

*/

export default {
  创建邮件模板: '创建邮件模板',
  邮件邀约提示1:
    '邮件邀约模板不超过10M，图片大小建议不超过5M，邮件邀约费用1点/条，发送邮件时，系统会根据发送的邮件预冻结对应的短信点数,邮件发送完成后,根据发送成功数进行抵扣,失败则退回对应的点数；',
  再发一条: '再发一条',
  实际触达客户数: '实际触达客户数',
  预计触达客户数: '预计触达客户数',
  转入点数: '转入点数',
  转入: '转入',
  邀约点数: '邀约点数',
  可分配邀约点数余量: '可分配邀约点数余量',
  邀约点数分配: '邀约点数分配',
  分配点数: '分配点数',
  模版内容: '模版内容',
  模板类型: '模板类型',
  官方平台: '官方平台',
  短信: '短信',
  渠道来源: '渠道来源',
  访问者: '访问者',
  更多客户数据追踪: '更多客户数据追踪',
  短链接访问人数: '短链接访问人数',
  短链接访问量: '短链接访问量',
  短链接ID: '短链接ID',
  邀约记录ID: '邀约记录ID',
  效果详情: '效果详情',
  发送邀约: '发送邀约',
  短信类型: '短信类型',
  我的名片: '我的名片',
  我的名片短链接: '我的名片短链接',
  个人云展预览: '个人云展预览',
  实现人脉裂变: '实现人脉裂变',
  一键分享云展: '一键分享云展',
  自定义短链接: '自定义短链接',
  参加的展览: '参加的展览',
  精准邀约提示33: '4、短信暂时仅支持国内+86（不包括中国香港、中国台湾、中国澳门）手机号的发送,国外的手机号暂不支持。',
  精准邀约提示32:
    '3、普通邀约短信费用1点/条,多媒体邀约短信费用3点/条,发送短信时,系统会根据发送的短信任务预冻结对应的短信点数,短信任务发送完成后,根据发送成功数进行抵扣,失败则退回对应的点数；',
  精准邀约提示31:
    '2、多媒体邀约短信,短信模板不能超过1.9M大小,视频上传文件不能超过50M（系统会自动压缩）,且建议播放时长不超过33秒,横屏视频建议1920*1080px,竖屏视频建议1080*1920px,图片大小建议50kb-1.8M范围,横屏图片建议1920*1080px,竖屏图片建议962*1300px;',
  精准邀约提示30:
    '1、普通邀约短信（纯文本）,70个字符（含标点符号）按1条短信计算,超过70个字符时,每增加67个字符加1点,每个标点符号、数字、中文、字母等均按照1个字符计算；',
  访问人数: '访问人数',
  点击次数: '点击次数',
  掀起采购狂潮: '掀起采购狂潮',
  了解企业实况: '了解企业实况',
  '多样化邀约形式获取海量客源,引爆客户流量': '多样化邀约形式获取海量客源,引爆客户流量',
  '亿级企业客户数据,一键发送短信精准邀约潜在客户': '亿级企业客户数据,一键发送短信精准邀约潜在客户',
  普通邀约: '普通邀约',
  多媒体邀约: '多媒体邀约',
  //
  压缩失败: '压缩失败',
  超出最大大小: '超出最大大小',
  插入变量: '插入变量',
  精准邀约提示29: '部分导入失败,格式有误。',
  导入成功: '导入成功',
  下载批量导入模板: '下载批量导入模板',
  批量导入: '批量导入',
  导入客户库群组: '导入客户库群组',
  导入客户库手机号: '导入客户库手机号',
  导入云数据: '导入云数据',
  请添加: '请添加',
  确定要全部清空吗: '确定要全部清空吗',
  个手机号: '个手机号',
  定时发送: '定时发送',
  重选模版: '重选模版',
  选择模版: '选择模版',
  请选择模板: '请选择模板',
  通讯录群组: '通讯录群组',
  个群组: '个群组',
  查询: '查询',
  重置: '重置',
  选择手机号: '选择手机号',
  精准邀约提示28: '您所属的企业还没有发布,请先发布再邀约！',
  精准邀约提示27: '您所属的企业还没有发布云采购,请先发布再邀约！',
  精准邀约提示26: '您所属的企业还没有报名参展展览,请先报名参展再邀约！',
  精准邀约提示25: '您所属的企业还没有创建任何直播,请先创建直播再邀约！',
  精准邀约提示24: '您所属的企业还没有创建任何企业3D,请联系您的管理员创建再邀请！',
  精准邀约提示23: '您个人的云展还没有创建,请先创建您的我的名片再邀约！',
  精准邀约提示22: '您所属的企业还没有创建任何优惠券,请联系您的企业管理员创建企业优惠券！',
  精准邀约提示21: '您所属的企业还没有创建任何云产品,请先创建至少一个云产品再邀约！',
  去发布: '去发布',
  去参展: '去参展',
  去创建: '去创建',
  邀约提示: '邀约提示',
  至少选择一个数据: '至少选择一个数据',
  选择: '选择',
  短信签名: '短信签名',
  模板详情: '模板详情',
  请: '请',
  当前账户余额不足: '当前账户余额不足',
  '金币/点': '金币/点',
  短信购买: '短信购买',
  模版ID: '模版ID',
  营销短信类型: '营销短信类型',
  精准邀约提示20: '2、官方模板无需审核,新建的自定义模板需要审核才可以发送；',
  精准邀约提示19: '1、普通邀约费用1点/条,多媒体邀约费用3点/条；',
  云数据库: '云数据库',
  预计触达人数: '预计触达人数',
  预计消耗短信: '预计消耗短信',
  计划状态: '计划状态',
  发送计划: '发送计划',
  选择模板: '选择模板',
  云数据精准邀约: '云数据精准邀约',
  选择邀约场景: '选择邀约场景',
  掀起起采购狂潮: '掀起起采购狂潮',
  发布优惠券: '发布优惠券',
  海量供应商报价: '海量供应商报价',
  发布采购需求: '发布采购需求',
  打造百万流量: '打造百万流量',
  发送展会邀请函: '发送展会邀请函',
  观众实时互动: '观众实时互动',
  分享直播: '分享直播',
  参观企业实况: '参观企业实况',
  邀请全球客户: '邀请全球客户',
  品牌曝光营销: '品牌曝光营销',
  产品上新通知: '产品上新通知',
  领现金红包: '领现金红包',
  邀请好友注册: '邀请好友注册',
  邀请好友: '邀请好友',
  参观云展系统: '参观云展系统',
  邀请全球采购商: '邀请全球采购商',

  立即邀约: '立即邀约',
  提交发送: '提交发送',
  发送时间: '发送时间',
  发送的模版: '发送的模版',
  邀约内容: '邀约内容',
  发送手机不能为空: '发送手机不能为空',
  发送手机: '发送手机',
  精准邀约提示18: '请输入11位有效手机号,仅支持国内（+86）手机号,直接输入11位手机号即可,回车键确定',
  发送主题最多输入10个字符: '发送主题最多输入10个字符',
  发送主题不能为空: '发送主题不能为空',
  精准邀约提示17: '仅作发送短信的标记,不作为短信内容发送；',
  邀约对象: '邀约对象',
  更多信息: '更多信息',
  提交审核: '提交审核',
  条短信收费: '条短信收费',
  按: '按',
  字符: '字符',
  约: '约',
  当前已输入: '当前已输入',
  短信效果预览: '短信效果预览',
  备注最多输入20个字符: '备注最多输入20个字符',
  精准邀约提示16: '1、可以用于简要记录当前模板的具体用途,如客户生日祝福',
  审核要求最多输入50个字符: '审核要求最多输入50个字符',
  精准邀约提示15:
    '1、您可以再此描述您的审核要求或期望,如模板仅需移动审核,联通、电信不需要审核,希望在2个小时内完成审核,若不要求,默认移动、联通、电信均需要审核',
  精准邀约提示14: '大小建议不要超过10M,支持格式MP4/3GP,建议上传格式最好为MP4、时长不超过33秒。',
  精准邀约提示13: '2、为了确保富信短信大小在1.9M以内,请上传图片时,建议确保图片大小控制在1.5M以内',
  精准邀约提示12: '1、支持格式PNG/JPG/GIF/JPEG,横图建议：1920*1080px,竖图建议：962*1300,高度不要超过3000px；',
  模板正文不能为空: '模板正文不能为空',
  精准邀约提示11: '3、1个短信模板允许插入1条短链接（优惠券除外）',
  精准邀约提示10: '2、企业主页短链接/我的名片短链接的变量默认为您所属的企业与您个人云展！',
  精准邀约提示9:
    '1、70个字符以内（含70）按1条短信计算,\n 2、71-134个字符，按2条短信计算；\n  3、超过134个字符时，每增加67个字符，多增加一条短信；\n 4、标点、数字、字母、中文都计算为1个字符（短信签名与拒收请回复R也会计算字符数），最多可输入1000个字符；',
  精准邀约提示8: '4、免流、退订等贴尾信息由系统自动添加,模板内不能含有贴尾字样；',
  精准邀约提示7: '3、模板正文内容不能包含特殊字符,如【】、[ ]等；',
  精准邀约提示6: '2、根据运营商的要求,模板大小需要在最大1.9M；',
  精准邀约提示5: '1、模板必须包含文字,且不能为纯文字、纯图片、纯音频、或纯视频；',
  自定义模版: '自定义模版',
  官方模版: '官方模版',
  精准邀约提示4:
    '4、发送短信、富信暂时仅支持国内+86（不包括中国香港、中国台湾、中国澳门）手机号的发送,国外的手机号暂不支持；',
  精准邀约提示3:
    '3、普通邀约短信费用1点/条,多媒体邀约短信费用3点/条,发送短信时,系统会根据发送的短信任务预冻结对应的短信点数,短信任务发送完成后,根据发送成功数进行抵扣,失败则退回对应的点数；',
  精准邀约提示2:
    '2、多媒体邀约短信,短信模板不能超过1.9M大小,视频上传文件不能超过50M（系统会自动压缩）,且建议播放时长不超过33秒,横屏视频建议1920*1080px,竖屏视频建议1080*1920px,图片大小建议50kb-1.8M范围,横屏图片建议1920*1080px,竖屏图片建议962*1300px;',
  精准邀约提示1:
    '1、普通邀约短信（纯文本）,70个字符(含标点符号)以内（包含短信签名）按1条短信计算,超过70个字符时,每增加67个字符,则多增加一条短信；每个标点、数字、字母、中文等均按照一个字符进行计算。',
  系统取消发送: '系统取消发送',
  用户取消发送: '用户取消发送',
  好友邀约: '好友邀约',
  我参展的展览: '我参展的展览',
  其他: '其他',
  多媒体: '多媒体',
  普通: '普通',
  短链接: '短链接',
  取消成功: '取消成功',
  发送状态: '发送状态',
  模板: '模板',
  邀约模板类型: '邀约模板类型',
  开始发送时间: '开始发送时间',
  发送主题: '发送主题',
  取消计划: '取消计划',
  确定要取消吗: '确定要取消吗',
  发送明细: '发送明细',
  邀约计划列表: '邀约计划列表',
  邀约场景推荐: '邀约场景推荐',
  发多媒体邀约: '发多媒体邀约',
  '平台提供海量精准大数据客户群,助力企业更高效找到潜在的客户':
    '平台提供海量精准大数据客户群,助力企业更高效找到潜在的客户',
  云展动力精准邀约服务使用协议: '云展动力精准邀约服务使用协议',
  立即充值即表示同意: '立即充值即表示同意',
  可用点数: '可用点数',
  赠送点数就是送你的点数: '赠送点数就是送你的点数',
  赠送点数: '赠送点数',
  邀约点数余量: '邀约点数余量',
  邀约模板: '邀约模板',
  邀约效果: '邀约效果',
  邀约记录: '邀约记录',
  邀约管理: '邀约管理',
}
